
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["fishbonediagram-demo-common","fishbonediagram-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__FishboneDiagram__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.en.md?type=demo')
};